import { create } from "zustand";

const lookupStore = create((set) => ({
  mostField: "recent",
  mostRecentBoxes: [],
  mostSelectedBoxes: [],
  setMostRecentBoxes: (boxes) => {
    set((state) => {
      return { mostRecentBoxes: boxes };
    });
  },
  setMostSelectedBoxes: (boxes) => {
    set((state) => {
      return { mostSelectedBoxes: boxes };
    });
  },
  setMostSelection: (field) => {
    set((state) => {
      return { mostField: field };
    });
  },
  displayedField: "exact",
  setDisplayedField: (field) => {
    set((state) => {
      return { displayedField: field };
    });
  },
  foundStuff: null,
  setFoundStuff: (stuff) => {
    set((state) => {
      return { foundStuff: stuff };
    });
  },
  activeSearch: "",
  setActiveSearch: (input) => {
    set((state) => {
      return { activeSearch: input };
    });
  },
  selectedBoxType: "all",
  setSelectedBoxType: (cat) => {
    set((state) => {
      return { selectedBoxType: cat };
    });
  },
}));

export default lookupStore;
